<template>
  <div @click="emitClick">TEST {{ message }}</div>
</template>

<script>
  export default {
    name: 'hello',
    props: {
      message: {
        type: String,
        default: function () {
          return 'hello'
        }
      }
    },
    exampleData: {
      message: 'Example message'
    },
    methods: {
      emitClick () {
        this.$emit('message', this.message)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Hello.vue?c368c1f0